var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#3CDD9F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 26.5,
    fill: "#3CDD9F",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 24.188c-7.074 0-12.813 5.066-12.813 11.312 0 3.176 1.489 6.04 3.875 8.094-.519 3.008-3.886 4.234-3.656 5.062 3.008 1.246 8.973-1.644 9.875-2.093.875.167 1.79.25 2.719.25 7.074 0 12.813-5.067 12.813-11.313S46.074 24.187 39 24.187z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iNzUiIHZpZXdCb3g9IjAgMCA3NSA3NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjM3LjUiIGZpbGw9IiMzQ0REOUYiLz4KPGNpcmNsZSBjeD0iMzcuNSIgY3k9IjM3LjUiIHI9IjI2LjUiIGZpbGw9IiMzQ0REOUYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzkgMjQuMTg3NUMzMS45MjU4IDI0LjE4NzUgMjYuMTg3NSAyOS4yNTM5IDI2LjE4NzUgMzUuNUMyNi4xODc1IDM4LjY3NTggMjcuNjc1OCA0MS41MzkxIDMwLjA2MjUgNDMuNTkzOEMyOS41NDMgNDYuNjAxNiAyNi4xNzU4IDQ3LjgyODEgMjYuNDA2MiA0OC42NTYyQzI5LjQxNDEgNDkuOTAyMyAzNS4zNzg5IDQ3LjAxMTcgMzYuMjgxMiA0Ni41NjI1QzM3LjE1NjIgNDYuNzMwNSAzOC4wNzAzIDQ2LjgxMjUgMzkgNDYuODEyNUM0Ni4wNzQyIDQ2LjgxMjUgNTEuODEyNSA0MS43NDYxIDUxLjgxMjUgMzUuNUM1MS44MTI1IDI5LjI1MzkgNDYuMDc0MiAyNC4xODc1IDM5IDI0LjE4NzVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgChatCircle as ReactComponent };